import BrandConfigurationReportTableData from "./BrandConfigurationReportTableData";
import BrandConfigurationReportTableFilter from "./BrandConfigReportTableFilterCard";
import BrandConfigurationReportChart from "../BrandConfigurationReportChart";

const tableHeadings = {
  brand: "Brand Name",
  brand_id: "Brand ID",
  backend_interface_name: "Affiliate System",
  ui_site_name: "Website",
  integration_status: "Integration Status",
  stuck_at: "Stuck At",
  reason: "Reason",
  last_run: "Last Run",
  action: "Action",
};

const BrandConfigurationReportTable = () => {
  return (
    <>
      <BrandConfigurationReportTableFilter />
      <BrandConfigurationReportChart />
      <BrandConfigurationReportTableData tableHeadings={tableHeadings} />
    </>
  );
};

export default BrandConfigurationReportTable;
